import React from "react";
import { NavLink } from "react-router-dom";

const Hero = () => {
  return (
    <section
      className="flex items-center justify-center min-h-[90vh] relative pt-16"
      style={{
        backgroundImage: "url(/assets/12.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="section-container py-14 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        {/* Left Side - Text */}
        <div className="rounded-md md:bg-transparent md:p-0 md:rounded-none title-space">
          <div className="section-title leading-relaxed">
            Unleash the Power of Packaging
          </div>
          <div className="md:text-6xl text-4xl font-bold text-primary-200">
          Built Light, Built {" "}
            <span className="text-primary-100 font-monoton font-normal">
            right
            </span>{" "}
            {/* Thermocol */}
          </div>
          <div className="text-gray-700 text-md leading-relaxed md:leading-loose">
            Choose Thermocraft for durable, eco-friendly thermocol packaging
            solutions that ensure safe, secure delivery of your fragile items,
            customized to your needs.
          </div>
          <NavLink to="/contact" className="flex max-w-[11rem] gap-2 flax py-4 bg-primary-200 text-white items-center font-semibold shadow-sharp-blue relative">
            Contact Us
            {/* <MdArrowOutward className="ml-2" /> */}
          </NavLink>
        </div>

        {/* Right Side - Empty or optional content */}
        <div className="relative">
          <img
            src={`/assets/hero1.webp`}
            alt="Product Packaging"
            className="w-full max-h-[30rem] h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
